import * as yup from "yup";

import { ERRORS_MESSAGE } from "@bms/constants";

export const validation = () => {
  return yup.object().shape({
    trader_name: yup.string().nullable().required(ERRORS_MESSAGE["REQUIRED"]),
    phone_number: yup
      .string()
      .nullable()
      .required(ERRORS_MESSAGE["REQUIRED"])
      .min(10, `10 ${ERRORS_MESSAGE["MIN"]}`),
    fax: yup.string().nullable().required(ERRORS_MESSAGE["REQUIRED"]),
    form_name: yup.string().nullable().required(ERRORS_MESSAGE["REQUIRED"]),
    address: yup.string().nullable().required(ERRORS_MESSAGE["REQUIRED"]),
  });
};
